( function( $ ){

  const $body = $( 'body' );
  const $header = $( '#site-header' );
  const $menu = $( '#menu-wrap' );
  const $toggle = $( '#mobile-menu-toggle' );
  const speed = 300;

  const menu_bp = $header.data( 'menu-bp' );


  function is_mobile () {
    return $toggle.is( ':visible' );
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap( $header.get(0), {
    onActivate () {
      $header.removeClass( 'is-hidden' );
      $toggle.addClass( 'is-active' );
      $menu.addClass( 'visible' );
      $body.addClass( 'menu-open' );
    },
    onDeactivate () {
      $toggle.removeClass( 'is-active' );
      $body.removeClass( 'menu-open' );
      setTimeout( function () {
        $menu.removeClass( 'visible' );
      }, speed );
    },
    initialFocus: $toggle.get(0),
  });


  let headerOffset = 0;
  let headerFrame = 0;

  function measureHeader () {
    headerOffset = $header.outerHeight() || 0;
    document.documentElement.style.setProperty( '--header-height', `${ headerOffset }px` );
  }

  function resize () {
    $header.toggleClass( 'mobile', !ThemeJS.Media_Queries.is_at_least( menu_bp ) );
    measureHeader();
    $menu.removeClass( 'mobile-transition-enabled' );
    setTimeout( function () {
      $menu.addClass( 'mobile-transition-enabled' );
    }, 0 );
    if ( ThemeJS.Media_Queries.is_at_least( menu_bp ) ) {
      focus_trap.deactivate();
      $( 'button.sub-menu-toggle' ).closest( 'li' ).each( function () {
        set_submenu_open( $(this), false );
      });
    }
  }


  // Hide only after the page has moved past the header, so the
  // spacer behind the fixed bar is already gone.
  let lastScrollY = window.scrollY || 0;
  const scrollThreshold = 5;

  function applyHeaderVisibility () {
    headerFrame = 0;
    const y = window.scrollY || 0;

    if ( y <= headerOffset || $body.hasClass( 'menu-open' ) ) {
      $header.removeClass( 'is-hidden' );
      lastScrollY = y;
      return;
    }

    if ( y > lastScrollY + scrollThreshold ) {
      $header.addClass( 'is-hidden' );
      lastScrollY = y;
    } else if ( y < lastScrollY - scrollThreshold ) {
      $header.removeClass( 'is-hidden' );
      lastScrollY = y;
    }
  }

  function syncHeaderVisibility () {
    if ( headerFrame ) {
      return;
    }

    headerFrame = window.requestAnimationFrame( applyHeaderVisibility );
  }

  // init header pad height and set header to fixed
  resize();
  $header.addClass( 'fixed' );
  applyHeaderVisibility();
  // trigger height recalculation on breakpoint change
  $( window ).on( 'breakpoint_changed', resize );
  window.addEventListener( 'scroll', syncHeaderVisibility, { passive: true } );

  // toggle mobile menu on hamburger click
  $toggle.click( () => {
    $body.hasClass( 'menu-open' ) ? focus_trap.deactivate() : focus_trap.activate();
  });


  // function to set submenus open/close
  function set_submenu_open ( $li, opening ) {
    let $btn = $( '> .link-wrap button.sub-menu-toggle', $li );
    if ( !$btn.length ) { return; }
    let $submenu = $( `#${ $btn.attr( 'aria-controls' ) }` );
    if ( !$submenu.length ) { return; }
    $btn.attr( 'aria-expanded', opening ? 'true' : 'false' );
		$submenu.attr( 'aria-hidden', opening ? 'false' : 'true' )[ opening ? 'slideDown' : 'slideUp' ]( speed );
  }


  // toggle submenus on click of caret btns
  $menu.on( 'click', 'button.sub-menu-toggle', function () {
    set_submenu_open( $(this).closest( 'li' ), $(this).attr( 'aria-expanded' ) == 'false' );
  });


  // close submenu on tab out
  $menu.on( 'focusout', 'li.menu-item-has-children', function ( e ) {
    if ( is_mobile() || $.contains( this, e.relatedTarget ) ) { return; }
    set_submenu_open( $(this), false );
  });


  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $menu.on( 'click', 'a[href="#"]', function ( e ) {
    e.preventDefault();
    let $btn = $( '+ .sub-menu-toggle', this );
    if ( $btn.length ) {
      $btn.click();
    }
  });

})( jQuery );
